import { Injectable } from '@angular/core';
import {
  RouteReuseStrategy,
  ActivatedRouteSnapshot,
  DetachedRouteHandle
} from '@angular/router';

@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {
  // Nie detachen (also nie zwischenspeichern)
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  // Muss implementiert werden, wird aber nie aufgerufen, weil shouldDetach immer false liefert
  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {
    // no-op
  }

  // Nie wieder anbringen
  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  // Immer null, weil wir nie etwas speichern
  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  // Immer neu instanziieren
  shouldReuseRoute(
    _future: ActivatedRouteSnapshot,
    _curr: ActivatedRouteSnapshot
  ): boolean {
    return false;
  }
}
